import { Controller } from "@hotwired/stimulus"
import { Loggable } from "./concerns/loggable"

export default class extends Controller {

  static targets = [ "container" ]

  initialize() {
    Loggable(this, { debug: true })
  }
  connect() {
    this.showQR()
  }

  showQR() {
    this.log("showing qr")

    this.containerTarget.innerHTML = ""

    new QRCode(this.containerTarget, {
      text: this.data.get("text"),
      width: this.data.get("width"),
      height: this.data.get("height"),
      colorDark: "#000000",
      colorLight: "#ffffff",
      correctLevel: QRCode.CorrectLevel.L
    })._el;
  }

}
